import { OfferStatusIdType } from '../../constants/StatusMap';

export enum RunningContractStatusType {
  PAID = 'PAID',
  ACTIVE = 'ACTIVE',
}

export interface SearchedValues {
  searchQuery?: string;
  offerId?: string;
  financialProduct?: string;
  offerReference?: string;
  offerMilesTemplateIds?: string;
  milesCompanyIds?: string[];
  creationDate?: string;
  modelName?: string;
  count?: number;
  offset?: number;
  creationDateFrom?: string;
  creationDateTo?: string;
  salesPerson?: string;
  statusId?: OfferStatusIdType[] | string;
  activationDate?: string;
  activationDateFrom?: string;
  activationDateTo?: string;
  pageSize?: number;
  // ONLY INTERNAL BETWEEN FE AND FES
  runningContractStatus?: RunningContractStatusType;
}
